import SettingsWrapper from '../settings/SettingsWrapper.vue';
import Index from './Index.vue';

export const routes = [
  {
    path: 'publications',
    component: SettingsWrapper,
    props: { keepAlive: false },
    meta: { permissions: ['administrator'] },
    children: [
      {
        path: '',
        name: 'telegram_publications',
        component: Index,
        meta: { permissions: ['administrator'] },
      },
    ],
  },
];
